import dataStorageManager, { BucketDefaultIDs, DMS_Operation } from '../../managers/data/DataStorageManager'
import dataQueryManager from '../../managers/network/DataQueryManager'
import { IRequest } from './RequestsServices'

export interface IServiceVehicle {
  id: number
  nombre_conductor: string
  rut_conductor: string
  patente_vehiculo: string
  tipo_vehiculo: null | string
  marca: null | string
  color: null | string
  fecha_registro: string
  fecha_actualizacion: string
  usuario_registro: number
  activo: boolean
  observaciones: string | null
}

export const defaultIServiceVehicle: IServiceVehicle = {
  id: 0,
  nombre_conductor: '',
  rut_conductor: '',
  patente_vehiculo: '',
  tipo_vehiculo: null,
  marca: null,
  color: null,
  fecha_registro: new Date().toISOString(),
  fecha_actualizacion: new Date().toISOString(),
  usuario_registro: 0,
  activo: true,
  observaciones: null,
}

export default class ServiceVehiclesServices {
  private bucketID: string | null = null

  constructor() {
    // Registrar el bucket para tripulantes
    this.bucketID = dataStorageManager.registerBucket<IServiceVehicle>(
      this.getAllVehicleServices.bind(this), // Asegúrate de enlazar el contexto correcto
      {
        refreshRatio: 5 * 60 * 1000, // Refrescar cada 5 minutos
        //preload: true, // Preload
        bucketID: BucketDefaultIDs.VEHICLE_SERVICES, // ID del bucket
        operations: new Map<string, DMS_Operation>([
          [
            'insertServiceVehicle',
            {
              operation: this.insertVehiculoService.bind(this),
              reloadAfter: true,
            },
          ],
          [
            'updateServiceVehicle',
            {
              operation: this.updateVehiculoService.bind(this),
              reloadAfter: true,
            },
          ],
        ]), // Las operaciones se añadiran despues
      },
    )
  }

  startup() {}

  async getAllVehicleServices(): Promise<IServiceVehicle[]> {
    try {
      const response = await dataQueryManager.addQuery<IServiceVehicle | IServiceVehicle[]>({
        query: `${import.meta.env.VITE_BASE_URL}/enrolamiento/1/op_select_servicio_vehiculo`,
        operation: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        params: [],
      })
      if (response.data && Array.isArray(response.data)) {
        return response.data
      } else if (response.data) {
        return [response.data]
      }
    } catch (error) {
      console.error('Error fetching users:', error)
    }
    return []
  }

  async insertVehiculoService(
    vehicleData: Omit<IServiceVehicle, 'id' | 'fecha_registro' | 'fecha_actualizacion'>,
  ): Promise<boolean> {
    try {
      const body = {
        op_insert_servicio_vehiculo: {
          nombre_conductor: vehicleData.nombre_conductor,
          rut_conductor: vehicleData.rut_conductor,
          patente_vehiculo: vehicleData.patente_vehiculo,
          tipo_vehiculo: vehicleData.tipo_vehiculo || '',
          marca: vehicleData.marca || '',
          color: vehicleData.color || '',
          usuario_registro: vehicleData.usuario_registro,
          activo: vehicleData.activo,
          observaciones: vehicleData.observaciones,
        },
      }

      const response = await dataQueryManager.addQuery<number>({
        query: `${import.meta.env.VITE_BASE_URL}/enrolamiento/1/op_insert_servicio_vehiculo`,
        operation: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        params: [],
        body: body,
      })
      if (response.data && typeof response.data === 'number') {
        return true
      }
    } catch (error) {
      console.error('Error inserting embarcacion:', error)
    }
    return false
  }

  async updateVehiculoService(vehicleData: IServiceVehicle): Promise<boolean> {
    try {
      const body = {
        op_update_servicio_vehiculo: {
          nombre_conductor: vehicleData.nombre_conductor,
          rut_conductor: vehicleData.rut_conductor,
          patente_vehiculo: vehicleData.patente_vehiculo,
          tipo_vehiculo: vehicleData.tipo_vehiculo,
          marca: vehicleData.marca,
          color: vehicleData.color,
          activo: vehicleData.activo,
          observaciones: vehicleData.observaciones,
          id: vehicleData.id,
        },
      }

      const response = await dataQueryManager.addQuery<number>({
        query: `${import.meta.env.VITE_BASE_URL}/enrolamiento/1/op_update_servicio_vehiculo`,
        operation: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        params: [],
        body,
      })
      if (response.data && typeof response.data === 'number') {
        return true
      }
    } catch (error) {
      console.error('Error updating viaje:', error)
    }
    return false
  }
}
